import { render, staticRenderFns } from "./ProductInfoImportant.vue?vue&type=template&id=5eeb97d3&scoped=true&"
import script from "./ProductInfoImportant.vue?vue&type=script&lang=js&"
export * from "./ProductInfoImportant.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoImportant.vue?vue&type=style&index=0&id=5eeb97d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eeb97d3",
  null
  
)

export default component.exports